import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useMediaQuery } from '@mui/material';

import ForNonDesktop from '../../components/ForNonDesktop';
import ChatButton from '../../components/HeaderActions/ChatButton';
import CloseButton from '../../components/HeaderActions/CloseButton';
import { selectAssignment } from '../../db/assignments/selectors';
import { i18nNS } from '../../i18n';
import routes, { AssignmentParams } from '../../pages/routes';
import { useAppSelector } from '../../store/hooks';
import { getUnseenComments } from '../../utils/activities';
import { forDesktop } from '../../utils/media-queries';

const useAssignmentAnalyticsHeaderActionsVM = () => {
  const params = useParams<AssignmentParams>();
  const assignment = useAppSelector((state) => selectAssignment(state, params.assignmentShortId));

  const numUnseenComments = assignment ? getUnseenComments(assignment) : 0;

  return { params, numUnseenComments };
};

const AssignmentAnalyticsHeaderActions = () => {
  const isDesktop = useMediaQuery(forDesktop);
  const { t } = useTranslation([i18nNS.ASSIGNMENT]);

  const { params, numUnseenComments } = useAssignmentAnalyticsHeaderActionsVM();

  return (
    <>
      <CloseButton
        to={routes.assignment.url(params)}
        edge={isDesktop ? 'end' : undefined}
        aria-label={t('click_to_close_assignment_analytics', { ns: i18nNS.ASSIGNMENT })}
      />
      <ForNonDesktop>
        <ChatButton edge="end" numUnseenComments={numUnseenComments} />
      </ForNonDesktop>
    </>
  );
};

export default AssignmentAnalyticsHeaderActions;
